import { getInitialStateFromConfig } from "helpers/form";
import { getBanks } from "sources/profile/organization";

const config = {
    inn: {
        // field
        label: "ИНН",
        inputProps: { name: "inn" },
    },
    kpp: {
        // field
        label: "КПП",
        inputProps: { name: "kpp" },
    },
    ogrn: {
        // field
        label: "ОГРН",
        inputProps: { name: "ogrn" },
    },
    bank: {
        // field
        label: "Полное наименование банка",
        inputProps: { name: "bank" },
    },
    ks: {
        // field
        label: "Корреспондентский счет",
        inputProps: { name: "ks" },
    },
    rs: {
        // field
        label: "Расчетный счет",
        inputProps: { name: "rs" },
    },
    bankId: {
        label: "БИК",
        inputProps: { name: "bankId" },
        url: getBanks,
        propName: (item) => [item.bankId, item.bank].filter(Boolean).join(" - "),
        idKey: "bankId",
        minimumInputLength: 3,
        menuPortalTarget: document.body,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
